'use strict';

import ckb from './ckb';
import da from './da';
import de from './de';
import en from './en';
import es from './es';
import fr from './fr';
import he from './he';
import it from './it';
import ja from './ja';
import ko from './ko';
import lv from './lv';
import nl from './nl';
import pl from './pl';
import pt_br from './pt_br';
import ro from './ro';
import ru from './ru';
import se from './se';
import ua from './ua';
import ur from './ur';
import zh_cn from './zh_cn';

export { ckb, da, de, en, es, fr, he, it, ja, ko, lv, nl, pl, pt_br, ro, ru, se, ua, ur, zh_cn };
export default { ckb, da, de, en, es, fr, he, it, ja, ko, lv, nl, pl, pt_br, ro, ru, se, ua, ur, zh_cn };
